// extracted by mini-css-extract-plugin
export default {"SideDrawer":"SideDrawer_SideDrawer__KB4TS","active":"SideDrawer_active__PL0mB"};